module.exports = __webpack_public_path__ + "static/media/fleet111.70a6cc95.jpg";